export const getExpressCheckoutRequest = {
  paymentOptions: true,
  cart: true,
  shippingOptions: true,
  customerAgreements: true,
};
